import { ReactComponent as LogoSvg } from "../assets/eliteVacances.svg";
import { ReactComponent as FacebookSVG } from "../assets/Facebook.svg";
import { ReactComponent as InstagramSVG } from "../assets/Instagram.svg";
import { ReactComponent as TikTokSVG } from "../assets/TikTok.svg";

const Navbar = () => {
  return (
    <nav className="navbar fixed-top navbar-expand-lg bg-navbar">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <LogoSvg height={50} className="bg-cream" />
        <div className="navbar-icons">
          <a
            href="https://www.instagram.com/elitevacances/"
            target="_blank"
            rel="noreferrer"
            className="round-gray"
          >
            <InstagramSVG height={40} className="bg-cream" />
          </a>

          <a
            href="https://www.tiktok.com/@elitevacances"
            target="_blank"
            rel="noreferrer"
            className="round-gray"
          >
            <TikTokSVG height={40} className="bg-cream" />
          </a>
          <a
            href="https://facebook.com/elitevacances"
            target="_blank"
            rel="noreferrer"
            className="round-gray"
          >
            <FacebookSVG height={40} className="bg-cream" />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
